import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MonthlyReports from '../MonthlyReports/MonthlyReports';
import WeeklyResponses from '../WeeklyReports/WeeklyReports';
import {
  TabButton,
  TabContent,
  TabsContainer,
  TabsHeader,
} from './ReportsTabs.Styles';

const ReportsTabs = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('weekly');

  return (
    <TabsContainer>
      <TabsHeader>
        <TabButton
          active={activeTab === 'weekly'}
          onClick={() => setActiveTab('weekly')}
        >
          {t('Weekly Responses Tab')}
        </TabButton>
        <TabButton
          active={activeTab === 'monthly'}
          onClick={() => setActiveTab('monthly')}
        >
          {t('Monthly Responses Tab')}
        </TabButton>
      </TabsHeader>

      <TabContent active={activeTab === 'weekly'}>
        <WeeklyResponses />
      </TabContent>

      <TabContent active={activeTab === 'monthly'}>
        <MonthlyReports />
      </TabContent>
    </TabsContainer>
  );
};

export default ReportsTabs;
